import { ContractMessage } from '../../../../../types/ContractMessage';
import { Button } from '../../../../cdl/Button/Button';
import { Modal } from '../../../../cdl/Modal/Modal';
import { Text } from '../../../../cdl/Text/Text';
import { ButtonGroup } from '../../../../common/buttons/ButtonGroup';
import { translate } from '../../../../common/helpers/translate.helper';
import { PartlyBoldTranslation } from '../../../../common/PartlyBoldTranslation';
import { Box } from '../../../../common/ui/Box';

interface ExcludeVesselFromContractModalProps {
    contract: ContractMessage;
    isSubmitting?: boolean;
    onConfirm: () => void;
    onDismiss: () => void;
}

export const ExcludeVesselFromContractModal = ({
    contract,
    isSubmitting = false,
    onConfirm,
    onDismiss,
}: ExcludeVesselFromContractModalProps) => {
    return (
        <Modal isOpen onDismiss={onDismiss} scrollable={false} dismissible={false}>
            <Box padding={24} display="grid" rowGap={16}>
                <Text variant="title">{translate('vessel.contracts.excludeModal.title')}</Text>
                <Text variant="body">
                    <PartlyBoldTranslation
                        translation={translate('vessel.contracts.excludeModal.description', {
                            contractName: contract.name,
                        })}
                    />
                </Text>

                <ButtonGroup justifyContent="flex-end">
                    <Button type="button" onClick={onDismiss} disabled={isSubmitting}>
                        {translate('btn.cancel')}
                    </Button>
                    <Button emphasis="high" type="button" onClick={onConfirm} isLoading={isSubmitting}>
                        {translate('vessel.contracts.actions.excludeVessel')}
                    </Button>
                </ButtonGroup>
            </Box>
        </Modal>
    );
};
